import {addParamToUrl, getUrlParameter, removeParamFromUrl} from "./utils/urlHelpers";
import {displayFilteredPlaces, updateFilter} from "./utils/filterRequests";
import {reformatDate} from "./utils/dateHelpers";
import {resetFilterValues} from "./utils/filterUtils";

const filterOrderBy = document.getElementById("order-by");

if (localStorage.getItem("filterOrderBy")) {
    filterOrderBy.value = localStorage.getItem("filterOrderBy");
}

filterOrderBy.addEventListener("change", orderByChangeHandler)

function orderByChangeHandler() {
    let orderBy = this.value;

    localStorage.setItem("filterOrderBy", orderBy);
    addParamToUrl("orderBy", orderBy);
    updateFilter();
}

function parseGetParams() {
    const reset = parseInt(getUrlParameter("reset"));
    if(reset === 1) {
        //re-assign all values depending on URL parameters
        resetFilterValues();
        removeParamFromUrl("reset");
    }

    const regionId = parseInt(getUrlParameter("region"));
    if (regionId !== localStorage.getItem("filterRegionId") && !isNaN(regionId)) {
        //console.log("reset, just region " + regionId);
        //specific case when we want to reset search and show just region
        //resetFilterValues();

        //reset country if region is set
        localStorage.removeItem("filterCountryId");
        localStorage.removeItem("filterCountryName");
        removeParamFromUrl("country");

        localStorage.setItem("filterRegionId", regionId);
        let regionRadioButton = document.querySelector('input[type=radio][name="region"][value="' + regionId + '"]');
        if(regionRadioButton) {
            regionRadioButton.checked = true;
        } else {
            console.warn("input for region " + regionId + " not found");
        }
        let regionNameElements = document.querySelectorAll('label[for=region_' + regionId + ']');
        if(regionNameElements && regionNameElements.length > 0) {
            let regionName = regionNameElements[0].innerHTML;
            localStorage.setItem('filterRegionName', regionName);
        } else {
            console.warn("label for region " + regionId + " not found");
        }
    }

    const countryId = parseInt(getUrlParameter("country"));
    if (countryId !== localStorage.getItem("filterCountryId") && !isNaN(countryId)) {
        //console.log("reset, just country " + countryId);

        //specific case when we want to reset search and show just region
        //resetFilterValues();

        //reset region if country is set
        localStorage.removeItem("filterRegionId");
        localStorage.removeItem("filterRegionName");
        removeParamFromUrl("region");

        localStorage.setItem("filterCountryId", countryId);
        let countryRadioButton = document.querySelector('input[type=radio][name="country"][value="' + countryId + '"]');
        if(countryRadioButton) {
            countryRadioButton.checked = true;
        } else {
            console.warn("input for country " + countryId + " not found");
        }

        let countryNameElements = document.querySelectorAll('label[for=country_' + countryId + ']');
        if(countryNameElements && countryNameElements.length > 0) {
            let countryName = countryNameElements[0].innerHTML;
            localStorage.setItem('filterCountryName', countryName);
        } else {
            console.warn("label for country " + countryId + " not found");
        }
    }

    let dates = getUrlParameter("dates");
    let datesValue = dates.split(" - ");

    let dateFrom = reformatDate(datesValue[0]);
    let dateTo = reformatDate(datesValue[1]);

    if (dateFrom && dateTo) {
        //console.log("dates " + dateFrom + " - " + dateTo);
        localStorage.setItem("filterDateFrom", dateFrom);
        localStorage.setItem("filterDateTo", dateTo);
    }

    let capacityMode = getUrlParameter("capacityMode");
    if (capacityMode !== localStorage.getItem("filterCapacityMode") && capacityMode.length > 0) {
        localStorage.setItem("filterCapacityMode", capacityMode);
    }

    let capacity = getUrlParameter("capacity");
    if (capacity !== localStorage.getItem("filterCapacity")) {
        localStorage.setItem("filterCapacity", capacity);
    }
    if (!capacity && !localStorage.getItem("filterCapacity")) {
        localStorage.setItem("filterCapacity", "1");
    }

    let feature = getUrlParameter("feature");
    if (feature) {
        //specific case when we want to reset search and show just category
        //resetFilterValues();

        localStorage.setItem("filterFeatures", feature);
    }

    let priceFrom = parseInt(getUrlParameter("priceFrom"));
    if (!isNaN(priceFrom) && priceFrom !== parseInt(localStorage.getItem("filter-pricePerNight-from"))) {
        localStorage.setItem("filter-pricePerNight-from", priceFrom + "");
    }

    let priceTo = parseInt(getUrlParameter("priceTo"));
    if (!isNaN(priceTo) && priceTo !== parseInt(localStorage.getItem("filter-pricePerNight-to"))) {
        localStorage.setItem("filter-pricePerNight-to", priceTo + "");
    }

    // let bedroomsFrom = parseInt(getUrlParameter("bedroomsFrom"));
    // if (!isNaN(bedroomsFrom) && bedroomsFrom !== parseInt(localStorage.getItem("filter-bedrooms-from"))) {
    //     localStorage.setItem("filter-bedrooms-from", bedroomsFrom + "");
    // }
    //
    // let bedroomsTo = parseInt(getUrlParameter("bedroomsTo"));
    // if (!isNaN(bedroomsTo) && bedroomsTo !== parseInt(localStorage.getItem("filter-bedrooms-to"))) {
    //     localStorage.setItem("filter-bedrooms-to", bedroomsTo + "");
    // }

    //it is named location, because can alternatively contain place number
    let location = getUrlParameter("location");
    if (location === "Jakákoliv oblast" || location === "Wohin reisen" || location === "Where to?" || location === "Region") {
        const regionValueEl = document.getElementById("filter-value-region");
        if(regionValueEl) {
            regionValueEl.placeholder = location;
        }
        removeParamFromUrl("location");
        localStorage.removeItem("filterCity");
    } else if(location) {
        //console.log("set location based on url with value " + location);
        localStorage.setItem("filterCity", location);
    } else {
        removeParamFromUrl("location");
        localStorage.removeItem("filterCity")
    }

    //number is in get parameter, that means place does not exist
    //display warning and remove number from URL
    removeParamFromUrl("number")
}

parseGetParams();

window.onpopstate = function(event) {
    setTimeout(function() {
        window.scroll(0, 0);
        window.location.reload(true);
    }, 50)
};

$(function () {
    //Display last visited places
    let width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    if (width >= 992) {
        if (localStorage.hasOwnProperty("visitedPlaces")) {
            let visitedPlaces = localStorage.getItem("visitedPlaces");
            let fetchPlaces = JSON.parse(visitedPlaces);

            if (fetchPlaces.length > 0) {
                const placesWrap = $("#visited-places");

                $.ajax({
                    url: "/parts/place/visited/simple",
                    method: "GET",
                    data: {
                        "ids": fetchPlaces.join()
                    },
                    success: function (result) {
                        placesWrap.html(result);
                    }
                })
            }
        }
    }

    const resetFilterBtn = $(".reset-filter");

    resetFilterBtn.click(function () {
        resetFilterValues();
        window.history.replaceState('', '', window.location.href.split("?")[0]);
        window.location.reload();
    })

    $(document).on('click', '.pagination-item', function () {
        const page = $(this).data("page");
        addParamToUrl("p", page);

        $('html, body').animate({
            scrollTop: $("#filter-results-wrap").offset().top - 60
        }, 10);

        displayFilteredPlaces(false);
    });

    $(document).on('click', '#pagination-next', function () {
        const current = $(".pagination-item--current");
        current.next().click();
    });

    $(document).on('click', '#pagination-prev', function () {
        const current = $(".pagination-item--current");
        current.prev().click();
    });

    $(document).on('click', '#pagination-next-button', function () {
        const current = $(".pagination-item--current");
        current.next().click();
    });

    $(document).on("change", "#side-filter input[type='checkbox']", function () {
        const id = $(this).val();

        //Only one theme category can be checked
        if ($(this).hasClass("theme-input")) {
            if (!$(this).is("checked")) {
                $(".theme-input").not("#theme_" + id).prop("checked", false);
            }
        }

        let values = $("#side-filter input[type='checkbox']:checked");
        let ids = [];

        removeParamFromUrl("feature");

        values.each(function () {
            ids.push($(this).val());
        });

        localStorage.setItem("filterFeatures", ids);
        if(ids.length > 0) {
            addParamToUrl("feature", ids);
        }

        removeParamFromUrl("p");

        if ($(this).hasClass("theme-input")) {
            $(this).closest('.form-check').addClass('filter-theme-loading');
        } else {
            $(this).closest('.custom-control').addClass('filter-checkbox-loading');
        }

        displayFilteredPlaces();
    });

    updateFilter(false);
});